import { MsalProvider } from '@azure/msal-react';
import { Route } from 'react-router';

import { Providers } from './context/use-providers';
import { Admin } from './pages/admin';
import { AdminTabs } from './pages/admin/tabs';
import { Auth as AuthPage } from './pages/auth';
import { Blackline } from './pages/blackline';
import { BlacklineBillingAudit } from './pages/blackline-billing-audit';
import { Dex360Audit } from './pages/dex360-audit';
import { Doc } from './pages/doc';
import { Charges } from './pages/fee/charges';
import { ChargeStateXrefs } from './pages/fee/state-mappings';
import { Geovera } from './pages/geovera';
import { GeoveraPolicyTransactions } from './pages/geovera/policy/policy-transactions';
import { GeoveraCheckTransactions } from './pages/geovera/specialty-check/check-transactions';
import { Home } from './pages/home';
import { Layout } from './pages/layout';
import { Northlight } from './pages/northlight';
import { NorthlightRenewals } from './pages/northlight-renewals';
import { Review } from './pages/northlight-renewals/review';
import { NorthlightPolicyTransactions } from './pages/northlight/policy-transactions';
import { PolicyStatus } from './pages/policy-status';
import { SubmissionScheduler } from './pages/submission-scheduler/index';
import { VelocityFeedAudit } from './pages/velocity-feed-audit';
import { WellsFargoFileIngestions } from './pages/wells-fargo/wells-fargo-file-ingestions';
import { WellsFargoTransactions } from './pages/wells-fargo/wells-fargo-transactions';
import { Workday } from './pages/workday';

export default function App({ instance }: { instance: any }) {
	return (
		<MsalProvider instance={instance}>
			<Providers>
				<Route element={<Layout />}>
					<Route index element={<Home />} />
					<Route path="/auth" element={<AuthPage />} />
					<Route path="/admin" element={<Admin />} />
					<Route path="/admin/import-type/:importTypeId" element={<AdminTabs />} />
					<Route path="/blackline" element={<Blackline />} />
					<Route
						path="/blackline-billing-audit"
						element={<BlacklineBillingAudit />}
					/>
					<Route path="/dex360-audit" element={<Dex360Audit />} />
					<Route path="/doc/data-classifications" element={<Doc />} />
					<Route path="/doc/document-classes" element={<Doc />} />
					<Route path="/doc/document-types" element={<Doc />} />
					<Route path="/doc/entity-types" element={<Doc />} />
					<Route path="/doc/metadata-types" element={<Doc />} />
					<Route path="/doc/source-systems" element={<Doc />} />
					<Route path="/fee/charges" element={<Charges />} />
					<Route
						path="/fee/state-mappings/:chargeId"
						element={<ChargeStateXrefs />}
					/>
					<Route path="/geovera/checks" element={<Geovera />} />
					<Route
						path="/geovera/checks/:fileIngestionId"
						element={<GeoveraCheckTransactions />}
					/>
					<Route path="/geovera/policies" element={<Geovera />} />
					<Route
						path="/geovera/policies/:fileIngestionId"
						element={<GeoveraPolicyTransactions />}
					/>
					<Route path="/northlight/policies" element={<Northlight />} />
					<Route
						path="/northlight/policies/:fileIngestionId"
						element={<NorthlightPolicyTransactions />}
					/>
					<Route path="/northlight-renewal" element={<NorthlightRenewals />} />
					<Route path="/northlight-renewal/review" element={<Review />} />
					<Route path="/policy-status" element={<PolicyStatus />} />
					<Route path="/submission-scheduler" element={<SubmissionScheduler />} />
					<Route path="/velocity-feed-audit" element={<VelocityFeedAudit />} />
					<Route path="/wells-fargo" element={<WellsFargoFileIngestions />} />
					<Route
						path="/wells-fargo/:fileIngestionId"
						element={<WellsFargoTransactions />}
					/>
					<Route path="/workday" element={<Workday />} />
				</Route>
			</Providers>
		</MsalProvider>
	);
}
